<template>
  <a
    class="ds-header__logo ds-header__logo--short"
    :href="homepageUrl"
  >
    <img
      width="32"
      height="32"
      :src="'/img/logos/favicon-32px.svg'"
      alt="Tagvenue"
    >
  </a>
</template>

<script>
export default {
  name: 'LogoShort',
  props: {
    homepageUrl: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.ds-header__logo--short {
  padding: 12px;
}
</style>
